import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CursorGlow = () => {
  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const x = useMotionValue(-500);
  const y = useMotionValue(-500);
  const sx = useSpring(x, { stiffness: 220, damping: 28, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 220, damping: 28, mass: 0.5 });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setActive(!!e.target.closest?.("a, button, [role=button], input"));
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (!enabled) return null;
  return (
    <>
      <motion.div
        data-testid="cursor-glow"
        style={{ x: sx, y: sy }}
        className="pointer-events-none fixed left-0 top-0 z-[60] -translate-x-1/2 -translate-y-1/2 mix-blend-screen"
      >
        <motion.div
          animate={{ scale: active ? 1.5 : 1, opacity: active ? 0.75 : 0.5 }}
          transition={{ duration: 0.35 }}
          className="h-[420px] w-[420px] rounded-full"
          style={{ background: "radial-gradient(circle, rgba(232,193,90,0.30) 0%, rgba(232,193,90,0.10) 30%, rgba(232,193,90,0) 65%)" }}
        />
      </motion.div>
      <motion.div
        style={{ x, y }}
        className="pointer-events-none fixed left-0 top-0 z-[61] -translate-x-1/2 -translate-y-1/2"
      >
        <motion.div
          animate={{ scale: active ? 2.2 : 1 }}
          transition={{ duration: 0.25 }}
          className="h-2 w-2 rounded-full bg-gold shadow-[0_0_18px_6px_rgba(232,193,90,0.55)]"
        />
      </motion.div>
    </>
  );
};
